export default {
    unauthorized: {
        title: 'Access denied',
        bodyBefore: "You don't have the",
        bodyAfter: ' scope. Contact your administrator to request access.',
    },
}
